module.exports = __webpack_public_path__ + "img/database.0deb51d2.svg";